import {
  ENTITY_TYPE_IDS,
  S_CORP_ENTITY_TYPE_NAMES,
  S_CORP_LABEL_SUFFIX,
  TAXED_AS,
} from "v2/constants/entityTypes";

const getSCorpEntityTypeName = (
  formationTypeId: string,
  formationTypeName: string
): string => {
  if (formationTypeId && formationTypeId === ENTITY_TYPE_IDS.ccorp) {
    return S_CORP_ENTITY_TYPE_NAMES.corporation;
  }
  if (formationTypeId && formationTypeId === ENTITY_TYPE_IDS.llc) {
    return S_CORP_ENTITY_TYPE_NAMES.llc;
  }

  return formationTypeName;
};

/**
 * Entity type name as shown to the user. An S-Corp election is a tax election
 * rather than a formation type, so it reads as a suffix on the type name.
 */
export const getEntityTypeLabel = (
  formationTypeName: string,
  taxedAs: string,
  formationTypeId: string
): string => {
  if (!formationTypeName) return "";
  if (taxedAs !== TAXED_AS.S_CORP) return formationTypeName;

  return `${getSCorpEntityTypeName(
    formationTypeId,
    formationTypeName
  )} ${S_CORP_LABEL_SUFFIX}`;
};
